module.exports = __webpack_public_path__ + "static/HowardThomas.adfd7030.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/HowardThomas.png
// module id = 1512
// module chunks = 35783957827783